/**
 * TeaSource Product Highlights - Mobile Layout
 *
 * Repositions the Product Highlights section on mobile devices.
 *
 * Desktop:
 *   Highlights remain below the product gallery.
 *
 * Mobile:
 *   Highlights are moved below the product description.
 *
 * This script only changes layout. It does not modify
 * the Highlight Features content or rendering.
 */

function moveProductHighlights() {

    const description = document.querySelector(".product--short-description");
    const highlights = document.querySelector(".product--highlight-features");
    const underGallery = document.querySelector(".product-information--under-gallery");

    if (!description || !highlights || !underGallery) {
        return;
    }

    if (window.innerWidth <= 767) {

        // Mobile
        if (highlights.previousElementSibling !== description) {
            description.insertAdjacentElement("afterend", highlights);
        }

    } else {

        // Desktop
        if (highlights.parentElement !== underGallery) {
            underGallery.prepend(highlights);
        }

    }

}

window.addEventListener("load", moveProductHighlights);
window.addEventListener("resize", moveProductHighlights);